declare var bootstrap: any;
import { Toaster } from "../customplugins/toaster.js";
import { Loader } from "../customplugins/loader.js";
document.addEventListener("DOMContentLoaded", () => {

    const txtMemberId = document.getElementById("memberId") as HTMLInputElement | null;
    if (txtMemberId) {
        txtMemberId.addEventListener("blur", checkuserid);
    }
    async function checkuserid(): Promise<void> {
        Loader.show();
        const memberId = txtMemberId.value.trim();
        const response = await fetch('/checkUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                member_id: memberId
            })
        });

        if (!response.ok) {

            throw new Error("Failed to fetch member details");
        }
        const data = await response.json();

        if (data?.status === true) {
            if (data?.message_Key === "MEMBER NOT FOUND") {
                Loader.hide();
                Toaster.error(
                    data?.message_Key ?? "MEMBER NOT FOUND")
            }
            else {
                Loader.hide();
                (document.getElementById("lblFullName") as HTMLInputElement).value =
                    data.fullName ?? "";
                (document.getElementById("lblMobile") as HTMLInputElement).value =
                    data.mobile ?? "";
                (document.getElementById("lblEmail") as HTMLInputElement).value =
                    data.email ?? "";
                (document.getElementById("hdnRegId") as HTMLInputElement).value =
                    data.regId ?? "0";
            }
        }
        else {
            Loader.hide();
            Toaster.error(
                data?.message_Key ?? "MEMBER NOT FOUND"
            );
        }
    }

});


